<template>
  <div class="md-layout" v-if="guide">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>info</md-icon>
        </div>
        <h4 class="title">
          Details
        </h4>
      </md-card-header>
      <md-card-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="title">Title</label>
                <md-select v-model="guide.title" name="title" id="title">
                  <md-option value="Mr">Mr</md-option>
                  <md-option value="Mrs">Mrs</md-option>
                  <md-option value="Miss">Miss</md-option>
                  <md-option value="Ms">Ms</md-option>
                  <md-option value="Dr">Dr</md-option>
                  <md-option value="Prof">Prof</md-option>
                  <md-option value="Rev">Rev</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>First Name</label>
                <md-input v-model="guide.first_name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>Last Name</label>
                <md-input v-model="guide.last_name" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Email Address</label>
                <md-input v-model="guide.email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Phone</label>
                <md-input v-model="guide.tel_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Mobile</label>
                <md-input v-model="guide.cell_num" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="guide.address_1" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-field>
                <label>Address</label>
                <md-input v-model="guide.address_2" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>City</label>
                <md-input v-model="guide.city" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>County/State</label>
                <md-input v-model="guide.county" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label for="country">Country</label>
                <md-select v-model="guide.country" name="country" id="country">
                  <md-option
                    v-for="country in countries"
                    :key="country"
                    :value="country"
                  >
                    {{ country }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label>Postcode</label>
                <md-input v-model="guide.postcode" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-field>
                <label for="gender">Gender</label>
                <md-select v-model="guide.gender" name="gender" id="gender">
                  <md-option value="Male">Male</md-option>
                  <md-option value="Female">Female</md-option>
                  <md-option value="NonBinary">Non-Binary</md-option>
                  <md-option value="Other">Other</md-option>
                  <md-option value="PreferNotToSay"
                    >Prefer not to say</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <md-datepicker
                v-model="guide.date_of_birth"
                md-immediately
                :md-model-type="String"
              >
                <label>Date of Birth</label>
              </md-datepicker>
            </div>

            <template v-if="canEdit">
              <div class="md-layout-item md-size-90 mt-4"></div>
              <div
                class="md-layout-item md-size-10 text-right button-holder"
              ></div>
            </template>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                class="md-raised md-success md-dense mt-4"
                @click.prevent="update"
                >{{ updateButtonText }}</md-button
              >
            </div>
          </div>
        </form>

        <guide-supplier-list
          v-if="updateMode == 'UPDATE'"
          :suppliers="guide.guides_for"
        />
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import guideApi from "@/services/api/guide";
import optionsApi from "@/services/api/options";

import GuideSupplierList from "./GuideSupplierList.vue";

export default {
  props: {
    guide: {
      type: Object
    }
  },

  data() {
    return {
      countries: []
    };
  },

  components: {
    GuideSupplierList
  },

  computed: {
    updateMode: function() {
      return this.guide.id ? "UPDATE" : "CREATE";
    },
    updateButtonText: function() {
      return this.updateMode == "UPDATE" ? "Update" : "Add";
    },
    canEdit: function() {
      return this.$allowed(["guide.manage"]);
    }
  },

  methods: {
    update() {
      let save = null;
      let message = "";

      switch (this.updateMode) {
        case "UPDATE":
          save = guideApi.update(this.guide);
          message = "Updated!";
          break;

        default:
          save = guideApi.create(this.guide);
          message = "Added!";
      }

      save.then(response => {
        this.$notify({
          timeout: 2500,
          message: message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });

        this.$emit("guideUpdated", {
          guide: response.data,
          mode: this.updateMode
        });
      });
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
